import { NgModule, Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ProductsService, DiscountsService } from '../../../../../services';
import { MERCHANT_TYPE, PAYMENT_TYPE, SYSTEM } from '../../../../../enums';
import { StandardDiscountApi, VolumeDiscountApi, ConfigurationApi } from '../../../../../../assets/js/lb-sdk';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

interface StandardDiscountForm {
  id?: string,
  productType?: { id: string, name: string },
  merchantType?: string,
  paymentType?: string,
  discount: number
}

@Component({
  selector: 'app-standard-discount-form',
  templateUrl: './standard-discount-form.component.html',
  styleUrls: ['./standard-discount-form.component.css']
})
export class StandardDiscountFormComponent implements OnInit {
  data: StandardDiscountForm;
  error: string;
  loading: boolean = false;
  merchantTypes = MERCHANT_TYPE;
  paymentTypes = PAYMENT_TYPE;
  volumeDiscounts;

  constructor(
    public modal: BsModalRef,
    public productService: ProductsService,
    private standardDiscountApi: StandardDiscountApi,
    private volumeDiscountApi: VolumeDiscountApi,
    private discountsService: DiscountsService,
    public toast: ToastrService
  ) {
    this.discountsService.fetchMaxDiscounts();
  }

  ngOnInit() {
    this.data = this.data || { discount: 0 };
    this.fetchVolumeDiscounts();
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(form) {
    if (form.valid) {
      const {
        id,
        productType,
        merchantType,
        paymentType,
        discount
      } = this.data;
      this.error = undefined;
      this.loading = true;
      (id ?
        this.standardDiscountApi
          .patchAttributes(id, {
            discount
          }) :
        this.standardDiscountApi
          .create({
            productType: productType.name,
            merchantType: merchantType,
            paymentType: paymentType,
            discount
          })
      ).pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(response => {
        this.modal.content.result = response;
        this.modal.hide();
      }, error => {
        if (error && error.message) {
          this.error = error.message.indexOf('Unique combination of') >= 0 ?
            'Already have a standard discount for the following data' :
            'Failed to create standard discount.';
        } else {
          this.error = 'Failed to create standard discount.';
        }
      });
    }
  }

  fetchVolumeDiscounts() {
    this.loading = true;
    this.error = undefined;
    this.volumeDiscountApi
      .find()
      .pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(response => {
        this.volumeDiscounts = response;
      },
      error => {
        this.error = 'An error occured while fetching the volume discounts.';
      });
  }

  getMaxDiscountOfProduct(productType, merchantType, paymentType) {
    if (productType && productType.name && merchantType && paymentType && SYSTEM.MAX_DISCOUNT[productType.name]) {
      var discount = (this.volumeDiscounts || [])
        .filter(volumeDiscount => {
          return (
            volumeDiscount.productType === productType.name &&
            volumeDiscount.merchantType === merchantType &&
            volumeDiscount.paymentType === paymentType
          );
        })
        .map(volumeDiscount => {
          return {
            rate: volumeDiscount.discount,
            unit: 'P' // DEFAULTS TO PERCENT
          }
        })[0];
      return SYSTEM.MAX_DISCOUNT[productType.name] - parseFloat(discount && discount.rate || 0);
    } else {
      return 100;
    }
  }
}
